const ServiceCategoryTypeEnum = {
  Web: {
    value: 1
  },
  WordAddin: {
    value: 2
  },
  LeFILING: {
    value: 3
  },
  LecheckManagment: {
    value: 100
  }
};

export default ServiceCategoryTypeEnum;
